import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../store/store';
import { select } from 'satcheljs/lib/legacy';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
/**
 * Returns if the Txp options page is in dirty state (user made changes to it)
 */
export default select({
    optionState: function () { return store; },
})(function isTxpOptionDirty(state) {
    var savedOptions = getCalendarConfiguration();
    var formOptions = state.optionState;
    if (!savedOptions) {
        return false;
    }
    var EventsFromEmailEnabled = getFallbackValueIfNull(formOptions.EventsFromEmailEnabled, savedOptions.EventsFromEmailEnabled);
    if (savedOptions.EventsFromEmailEnabled !== EventsFromEmailEnabled) {
        return true;
    }
    if (!EventsFromEmailEnabled) {
        // if savedOptions.EventsFromEmailEnabled == EventsFromEmailEnabled == false,
        // return not dirty since we don't have to check rest of the flags
        return false;
    }
    var CreateEventsFromEmailAsPrivate = getFallbackValueIfNull(formOptions.CreateEventsFromEmailAsPrivate, savedOptions.CreateEventsFromEmailAsPrivate);
    if (CreateEventsFromEmailAsPrivate !== savedOptions.CreateEventsFromEmailAsPrivate) {
        return true;
    }
    var isEventFlagDirty = false;
    // Validate if the event flags are changed
    Object.keys(formOptions.Events).map(function (eventType) {
        var eventEnabled = getFallbackValueIfNull(formOptions.Events[eventType], savedOptions[eventType]);
        if (eventEnabled !== savedOptions[eventType]) {
            isEventFlagDirty = true;
        }
    });
    return isEventFlagDirty;
});
//# sourceMappingURL=isTxpOptionDirty.js.map